const JOBS_ENDPOINTS = {
  SEARCH_JOBS: "frontend/jobs/search",
  JOBS_FILTER: "frontend/jobs/filter-options",
  // SEARCH_JOBS: "/search",
  ESTIMATED_SALARY: "/estimated-salary",
  JOBS_BY_CITY_AND_STATE: "frontend/jobs/city",
  APPLY_JOB: "frontend/jobs",
  JOB_DETAIL: "frontend/jobs",
  PUBLIC_JOB_DETAIL: "frontend/jobs",
  SIMILAR_JOBS: "frontend/jobs",
  JOB_TRACKING: "/frontend/job-analytics/track",
  APPLY_CLICK: "/public/jobs",
  TOGGLE_BOOKMARK: "/frontend/jobs/bookmarks/toggle",
  CHECK_MULTIPLE_BOOKMARKS: "/frontend/jobs/bookmarks/check-multiple",
  CHECK_BOOKMARK: "/frontend/jobs/bookmarks/check",
  GET_BOOKMARK_JOB: "/frontend/jobs/bookmarks",
  NURSE_PROFILE: "/frontend/nurse-profile/complete",
  JOB_STATUS: "/nurse/job-applications",
  SCHEDULE_INTERVIEW: "/nurse/job-applications",
  JOBS_DOCUMENT: "/frontend/jobs",
  APPLYED_JOB: "/frontend/jobs",
  PERSONALIZED_JOBS: "/frontend/personalized-jobs",
};

export default JOBS_ENDPOINTS;
